import { render, staticRenderFns } from "./ContenidoEvaluacionProveedor.vue?vue&type=template&id=1177e806&"
import script from "./ContenidoEvaluacionProveedor.vue?vue&type=script&lang=js&"
export * from "./ContenidoEvaluacionProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports